import { API_BASE_URL, endpoints } from "./config";
import { authHeadersForGet } from "./http";
import { Message } from "../types/message";

export const messagesApi = {
  getByClientReference: async (clientReference: string): Promise<Message[]> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.messages.getByClient(clientReference)}`,
      { headers: authHeadersForGet() }
    );
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return response.json();
  },

  getBySaleReference: async (saleReference: string): Promise<Message[]> => {
    const response = await fetch(
      `${API_BASE_URL}/messages/sale/${saleReference}`,
      { headers: authHeadersForGet() }
    );
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return response.json();
  },
};
